type WpImage = { url: string };

export type WpStylePost = {
  id: string;
  slug: string;
  date: string;
  state: BlogCore.PostState;
  ribbon: BlogCore.Ribbon;
  categories: string[];
  title: { rendered: string };
  excerpt: { rendered: string };
  content: { rendered: string };
  yoast_head_json: { og_image: WpImage[]; og_description: string };
};

export type WpStyleCategory = {
  id: string;
  name: string;
  count: number;
};

function imageList(image: string | null | undefined): WpImage[] {
  return image ? [{ url: image }] : [];
}

export function mapPostToWp(
  post: BlogCore.Post,
  categoryIds: string[] = [],
  htmlContent = '',
): WpStylePost {
  return {
    id: post.slug,
    slug: post.slug,
    date: post.starts_at,
    state: post.state,
    ribbon: post.ribbon,
    categories: categoryIds,
    title: { rendered: post.title || '' },
    excerpt: { rendered: post.subtitle || '' },
    content: { rendered: htmlContent },
    yoast_head_json: {
      og_image: imageList(post.image),
      og_description: post.subtitle || '',
    },
  };
}

export function mapCategoriesToWp(categories: BlogCore.Category[]): {
  posts: WpStylePost[];
  categories: WpStyleCategory[];
} {
  const seen = new Set<string>();
  const posts: WpStylePost[] = [];
  const wpCategories: WpStyleCategory[] = [];

  for (const cat of categories) {
    wpCategories.push({
      id: cat.id,
      name: cat.name,
      count: cat.count ?? cat.posts?.length ?? 0,
    });

    for (const post of cat.posts || []) {
      if (seen.has(post.slug)) continue;
      seen.add(post.slug);
      posts.push(mapPostToWp(post, [cat.id]));
    }
  }

  return { posts, categories: wpCategories };
}
